/**
 * Portal Entry Point for Contact Domain
 *
 * Registers custom CRUD block component for contact method management.
 * Imported by the portal's virtual:portal-entries module.
 */

import { registerBlockComponent } from '@ja/crud/services/componentRegistry'

registerBlockComponent(
  'Contact::ContactMethodsBlock',
  () => import('./Components/ContactMethodsBlock.vue'),
  'contact',
)
